export var uiAngleBottom = [
    'M7.8 9.66L5.08 6.9C4.97 6.79 4.97 6.61 5.08 6.5L5.25 6.34C5.36 6.23 5.54 6.23 5.65 6.34L8 8.73L10.35 6.34C10.46 6.23 10.64 6.23 10.75 6.34L10.92 6.51C11.03 6.62 11.03 6.79 10.92 6.9L8.2 9.66C8.09 9.77 7.91 9.77 7.8 9.66Z',
];
